import PropTypes from 'prop-types';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';

// A titled block above the base policy picker, in the picker's own surface colors so they read as one.
const ModalSectionCard = ({ children, icon, title }) => (
  <Stack
    sx={{
      border: '1px solid #5B5B5B',
      borderRadius: '8px',
      backgroundColor: '#454545',
      overflow: 'hidden',
    }}>
    <Stack
      direction="row"
      alignItems="center"
      gap={0.75}
      sx={{ px: 1.25, py: 0.85, borderBottom: '1px solid #5B5B5B' }}>
      <Iconify icon={icon} width={16} height={16} color="#87C8E0" />
      <Typography sx={{ color: '#87C8E0', fontSize: '0.75rem', fontWeight: 700 }}>
        {title}
      </Typography>
    </Stack>
    <Stack gap={0.6} sx={{ px: 1.25, py: 1 }}>
      {children}
    </Stack>
  </Stack>
);

export const ModalSectionBullet = ({ children, tooltip }) => (
  <Stack direction="row" gap={0.75} alignItems="flex-start">
    <Box component="span" sx={{ color: '#87C8E0', lineHeight: 1.5, fontSize: '0.78rem' }}>
      •
    </Box>
    <Typography sx={{ color: '#F3F4F6', fontSize: '0.78rem' }}>
      {children}
      {tooltip ? (
        <Tooltip
          title={tooltip}
          arrow
          componentsProps={{ tooltip: { sx: { bgcolor: '#3F3F3F', maxWidth: 320 } } }}>
          <Box
            component="span"
            display="inline-flex"
            sx={{ ml: 0.5, verticalAlign: 'text-bottom' }}>
            <Iconify icon="material-symbols:info-outline" width={14} height={14} color="#9CA3AF" />
          </Box>
        </Tooltip>
      ) : null}
    </Typography>
  </Stack>
);

ModalSectionCard.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

ModalSectionBullet.propTypes = {
  children: PropTypes.node,
  tooltip: PropTypes.string,
};

export default ModalSectionCard;
